import MiscService from "@/services/MicService";

/** Override Settings by Acronym */
async function getConfig() {
    return new Promise(async (resolve, reject) => {
        /* Default Config Data*/
        let confObj = {
            /* Titulo de la web */
            title: '',
            showAcronym: true,
            /* Acronimo de la web */
            acronimo: 'test',
            /* Logo para el login*/
            logoLogin: '',
            /* Logo pequeño para el Dashboard*/
            logoMinPanel: '',
            /* Logo grande para el Dashboard*/
            logoPanel: '',
            /* Favicon panel */
            favicon: '',
            /* Version del panel */
            sidVersion: '1.6.4',
            /* Logo de la US */
            logoUS: {
                img: 'us-full.svg',
                link: 'https://www.us.es',
                title: 'Universidad de Sevilla'
            },
            /* Logo Organo Institucional */
            logoOrgano: {
                img: '',
                link: '',
                title: ''
            },
            /* Logo empresa/entidad */
            logoCliente: {
                img: '',
                link: '',
                title: ''
            },
            /* Mensaje pie de pagina de proyecto */
            footerLegend: ''
        }


        let response = await MiscService.getAcronym()
        let acronimo = response.data.data.acronym ? response.data.data.acronym : process.env.VUE_APP_PROJECT_ACRONYM
        if (await acronimo) {
            switch (acronimo) {
                /**** Proyecto Gri ****/
                case "gri":
                    confObj.title = "Gri Panel"
                    confObj.showAcronym = true,
                        confObj.acronimo = acronimo,
                        confObj.logoLogin = "GRI_Logo.svg",
                        confObj.logoMinPanel = "",
                        confObj.logoPanel = "GRI_Logo_NavBar.svg",
                        confObj.favicon = "default.ico",
                        confObj.logoOrgano = {
                            img: 'logo-gie-full.png',
                            link: '',
                            title: 'Escuela Técnica Superior de Ingeniería (Sevilla)'
                        },
                        confObj.logoCliente = {
                            img: 'GRI_Logo.svg',
                            link: '',
                            title: 'Gri'
                        },
                        confObj.footerLegend = 'Proyecto GRI Renewable Industries realizado con la colaboración de Universidad de Sevilla'
                    break;
                /**** Proyecto Safewater ****/
                case "safewater":
                    confObj.title = "Safewater Panel"
                    confObj.showAcronym = true,
                        confObj.acronimo = acronimo,
                        confObj.logoLogin = "SafeWaterLetras.svg",
                        confObj.logoMinPanel = "safewater-min.png",
                        confObj.logoPanel = "SafewaterLogo.svg",
                        confObj.favicon = "SafewaterLogoICO.ico",
                        confObj.logoUS = {
                            img: 'andalucia.svg',
                            link: 'https://www.us.es',
                            title: 'Universidad de Sevilla'
                        },
                        confObj.logoOrgano = {
                            img: 'logo-aicia.jpg',
                            link: '',
                            title: 'AICIA'
                        },
                        confObj.logoCliente = {
                            img: 'SafewaterLogo.svg',
                            link: '',
                            title: 'Safewater'
                        },
                        confObj.footerLegend = 'Proyecto Safewater realizado con la colaboración de Universidad de Sevilla'
                    break;
                /**** Proyecto Encina ****/
                case "encina":
                    confObj.title = "Encina Panel"
                    confObj.showAcronym = true,
                        confObj.acronimo = acronimo,
                        confObj.logoLogin = "encina-login.png",
                        confObj.logoMinPanel = "encina-min.png",
                        confObj.logoPanel = "encina-full.png",
                        confObj.favicon = "default.ico",
                        confObj.logoOrgano = {
                            img: 'logo-gie-full.png',
                            link: 'https://etsi.us.es',
                            title: 'Escuela Técnica Superior de Ingeniería (Sevilla)'
                        },
                        confObj.logoCliente = {
                            img: 'encina-full.png',
                            link: '',
                            title: 'Encina'
                        },
                        confObj.footerLegend = 'Proyecto Encina realizado con la colaboración de Universidad de Sevilla'
                    break;
                /**** Proyecto Cepsa ****/
                case "cepsa":
                    confObj.title = "Cepsa Panel"
                    confObj.showAcronym = true,
                        confObj.acronimo = acronimo,
                        confObj.logoLogin = "cepsa-login.png",
                        confObj.logoMinPanel = "cepsa-min.png",
                        confObj.logoPanel = "cepsa-full.png",
                        confObj.favicon = "cepsa.ico",
                        confObj.logoOrgano = {
                            img: 'huelva-full.png',
                            link: 'https://www.uhu.es/',
                            title: 'Universidad de Huelva'
                        },
                        confObj.logoCliente = {
                            img: 'cepsa-full.png',
                            link: 'https://www.cepsa.es',
                            title: 'Cepsa'
                        },
                        confObj.footerLegend = 'Proyecto Cepsa realizado con la colaboración de Universidad de Sevilla'
                    break;
                /**** Proyecto MPAscensores ****/
                case "mpascensores":
                    confObj.title = "MPAscensores Panel"
                    confObj.showAcronym = false,
                        confObj.acronimo = acronimo,
                        confObj.logoLogin = "mpascensores-login.png",
                        confObj.logoMinPanel = "mpascensores-min.png",
                        confObj.logoPanel = "mpascensores-full.png",
                        confObj.favicon = "mpascensores.ico",
                        confObj.logoOrgano = {
                            img: 'logo-gie-full.png',
                            link: 'https://etsi.us.es',
                            title: 'Escuela Técnica Superior de Ingeniería (Sevilla)'
                        },
                        confObj.logoCliente = {
                            img: 'mpascensores-full.png',
                            link: 'https://www.mpascensores.com',
                            title: 'MPAscensores'
                        },
                        confObj.footerLegend = 'Proyecto MPAscensores realizado con la colaboración de Universidad de Sevilla'
                    break;
                /**** Proyecto Agro ****/
                case "agro":
                    confObj.title = "Agro Panel"
                    confObj.showAcronym = true,
                        confObj.acronimo = acronimo,
                        confObj.logoLogin = "agro-login.png",
                        confObj.logoMinPanel = "agro-min.png",
                        confObj.logoPanel = "agro-full.png",
                        confObj.favicon = "agro.ico",
                        confObj.logoOrgano = {
                            img: 'logo-gie-full.png',
                            link: 'https://etsi.us.es',
                            title: 'Escuela Técnica Superior de Ingeniería (Sevilla)'
                        },
                        confObj.logoCliente = {
                            img: 'azvi-full.png',
                            link: 'https://www.etsi.us.es',
                            title: 'Grupo Ingenieria electrónica'
                        },
                        confObj.footerLegend = 'Proyecto Agro realizado con la colaboración de Universidad de Sevilla'
                    break;
                /**** Proyecto AIC3 ****/
                case "aic3":
                    confObj.title = "AIC3 Panel"
                    confObj.showAcronym = true,
                        confObj.acronimo = acronimo,
                        confObj.logoLogin = "azvi-full.png",
                        confObj.logoMinPanel = "azvi-simple-logo.jpeg",
                        confObj.logoPanel = "azvi-only.jpg",
                        confObj.favicon = "default.ico",
                        confObj.logoOrgano = {
                            img: 'logo-cdti-alt.jpg',
                            link: 'https://www.cdti.es/',
                            title: 'Centro para el Desarrollo Tecnológico Industrial'
                        },
                        confObj.logoCliente = {
                            img: 'azvi-full.png',
                            link: 'https://www.azvi.es',
                            title: 'Grupo azvi'
                        },
                        confObj.footerLegend = 'Proyecto AZVI-AIC3 realizado con la colaboración de Universidad de Sevilla, AZVI y CDTI'
                    break;
                /**** Proyecto LifeIoT ****/
                case "lifeiot":
                    confObj.title = "Lifeiot"
                    confObj.showAcronym = true,
                        confObj.acronimo = acronimo,
                        confObj.logoLogin = "lifeiot-login.png",
                        confObj.logoMinPanel = "lifeiot-min.png",
                        confObj.logoPanel = "lifeiot-full.png",
                        confObj.favicon = "default.ico"
                    break;
                /**** Proyecto doñana 4.0 ****/
                case "don40":
                    confObj.title = "Doñana 4.0"
                    confObj.showAcronym = true,
                        confObj.acronimo = acronimo,
                        confObj.logoLogin = "don40-login.png",
                        confObj.logoMinPanel = "don40-min.png",
                        confObj.logoPanel = "don40-full.png",
                        confObj.favicon = "default.ico",
                        confObj.logoOrgano = {
                            img: 'chg-ministerio.png',
                            link: 'https://www.miteco.gob.es',
                            title: ''
                        },
                        confObj.logoCliente = {
                            img: 'chg-logo.png',
                            link: 'https://www.chguadalquivir.es',
                            title: 'confObjederación Hidrográfica del Guadalquivir'
                        },
                        confObj.footerLegend = 'Proyecto Doñana4.0 realizado con la colaboración de Universidad de Sevilla y confObjederación Hidrográfica del Guadalquivir'
                    break;
                /**** Proyecto ACS ****/
                case "acs":
                    confObj.title = "Atlantic Copper"
                    confObj.showAcronym = false,
                        confObj.acronimo = acronimo,
                        confObj.logoLogin = "acs-login.png",
                        confObj.logoMinPanel = "acs-min.png",
                        confObj.logoPanel = "acs-full.png",
                        confObj.favicon = "acs.ico",
                        confObj.logoOrgano = {
                            img: 'huelva-full.png',
                            link: 'https://www.uhu.es',
                            title: 'Universidad de Huelva'
                        },
                        confObj.logoCliente = {
                            img: '',
                            link: '',
                            title: ''
                        },
                        confObj.footerLegend = 'Proyecto Atlantic Copper realizado con la colaboración de Universidad de Sevilla y Universidad de Huelva'
                    break;
                /**** Proyecto iot4shm ****/
                case "iot4shm":
                    confObj.title = "Iot4shm"
                    confObj.showAcronym = true,
                        confObj.acronimo = acronimo,
                        confObj.logoLogin = "iot4shm-login.png",
                        confObj.logoMinPanel = "iot4shm-min.png",
                        confObj.logoPanel = "iot4shm-full.png",
                        confObj.favicon = "default.ico",
                        confObj.logoOrgano = {
                            img: 'logo-gie-full.png',
                            link: 'https://etsi.us.es',
                            title: 'Escuela Técnica Superior de Ingeniería (Sevilla)'
                        },
                        confObj.logoCliente = {
                            img: 'navarra-publica-logo.png',
                            link: 'https://www.unavarra.es/',
                            title: 'Universidad Pública de Navarra'
                        },
                        confObj.footerLegend = 'Proyecto IoT4SHM realizado con la colaboración de Universidad de Sevilla'

                    break;
            }
        }

        resolve(confObj)
    });
}


export default getConfig();